export enum DocumentStatsType {
  ValleyOfDeath = 'ValleyOfDeath',
  Hot = 'Hot',
  Signed = 'Signed',
  Expired = 'Expired',
  Won = 'Won',
  WonLastMonth = 'WonLastMonth',
  Estimated = 'Estimated',
  Active = 'Active',
  Sent = 'Sent',
  HitTotal = 'HitTotal',
}
